import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { DataService } from '../service/data.service';
import { ApiService } from '../custom-services/ApiService';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-faq-new',
    templateUrl: './faq-new.component.html',
    styleUrls: ['./faq-new.component.css'],
    standalone: false
})
export class FaqNewComponent implements OnInit {

  baseUrl:string = environment.taxpayer_base_url;
  basicConfigDataApiPath: string = '/filingservice/v3/api/getBasicConfigData';
  currentAssessmentYear: string = '2026-2027';
  currentIncomeYearArray:string[] = ['01-07-2025','30-06-2026'];

  constructor(private router:Router,

    private apiService:ApiService,
    private toastr: ToastrService) { }

  ngOnInit(): void {


  }

  onBacktoMainPage() {
    localStorage.clear();
    this.router.navigate(["/auth/sign-in"]);
  }

}
